module.exports = __webpack_public_path__ + "static/img/Entertainment.1265066c.png";